export default "__VITE_ASSET__DpwXY8lV__"